module.exports = __webpack_public_path__ + "08ff3979c54c1cd44cec0d62387f7301.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/phone.png
 ** module id = 1578
 ** module chunks = 0
 **/